import { render, staticRenderFns } from "./open-account.vue?vue&type=template&id=45a57afe&scoped=true&"
import script from "./open-account.vue?vue&type=script&lang=js&"
export * from "./open-account.vue?vue&type=script&lang=js&"
import style0 from "./open-account.vue?vue&type=style&index=0&id=45a57afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a57afe",
  null
  
)

export default component.exports